export const ProgressIndicatorStyles = {
  container: 'bg-white w-full',
  indicatorPlaceholder: 'bg-white150 w-full',
  indicator: 'bg-skyblue800 h-2',
}
